
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { filter, cons, singleton, tail, append, empty, head, isEmpty, ofArray, map, tryFind } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { FormContainer } from "../../Components/FormContainer.js";
import { Input } from "../../Components/Input.js";
import { Msg } from "./Types.js";
import { defaultArg, unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { BusinessUnitId__get_unwrap, FormState__getValidation } from "../../Shared/Shared.js";
import { TextArea } from "../../Components/TextArea.js";
import { Select } from "../../Components/Select.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { initNewView, update as update_1, initEditView } from "./State.js";
import { tryFind as tryFind_1, ofList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { List_groupBy } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { createObj, comparePrimitives, compare, structuralHash, equals } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { contains, ofList as ofList_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Set.js";
import { empty as empty_1, singleton as singleton_1, append as append_1, delay, unfold, concat, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { RouterModule_encodeQueryString, RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { Skeleton } from "../../Components/Skeleton.js";
import { reactElement, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { withoutOnboardingTourQueryParams, isBusinessUnitsTourFormPhase } from "../../Common.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { TourGuideLocale, TourStep, TourGuide } from "../../Components/TourGuide.js";

export function BusinessUnitForm(props) {
    let Header, matchValue_2, Label_2, Options, bu_3;
    const t = useTranslation()[0];
    let selectedBusinessUnit;
    const matchValue = props.Form.SelectedParentBusinessUnitId;
    if (matchValue == null) {
        selectedBusinessUnit = undefined;
    }
    else {
        const selectedParentBusinessUnitId = matchValue;
        selectedBusinessUnit = tryFind((bu) => (bu.Id === selectedParentBusinessUnitId), props.BusinessUnits);
    }
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return createElement(FormContainer, (Header = t((matchValue_2 = props.FormKind, (matchValue_2.tag === 0) ? "business_units.form.create_title" : ((matchValue_2.tag === 1) ? "business_units.form.edit_title" : "business_units.form.create_title"))), {
        Children: ofArray([createElement(Input, {
            ComponentState: componentState,
            Label: t("general.name"),
            OnChange: (arg) => {
                props.Dispatch(new Msg(0, [arg]));
            },
            TestId: "create-business-unit-form-name",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "name")),
            Value: props.Form.Name,
        }), createElement(TextArea, {
            ComponentState: componentState,
            Label: t("general.description"),
            OnChange: (arg_1) => {
                props.Dispatch(new Msg(1, [arg_1]));
            },
            TestId: "create-business-unit-form-description",
            Value: props.Form.Description,
        }), createElement(Select, (Label_2 = t("business_units.form.parent_business_unit"), (Options = map((bu_1) => ({
            label: bu_1.Name,
            value: bu_1,
        }), props.BusinessUnits), {
            ComponentState: componentState,
            IsClearable: true,
            Label: unwrap(Label_2),
            NoOptionsMessage: t("business_units.form.no_parent_found"),
            OnChange: (bu_2) => {
                props.Dispatch(new Msg(2, [bu_2]));
            },
            Options: Options,
            PlaceholderKey: "",
            TestId: "create-business-unit-form-select",
            Value: unwrap((selectedBusinessUnit == null) ? undefined : ((bu_3 = selectedBusinessUnit, {
                label: bu_3.Name,
                value: bu_3,
            }))),
        })))]),
        FormState: props.FormState,
        Header: Header,
        OnBack: props.OnBack,
        OnSave: props.OnSave,
    }));
}

export function EditBusinessUnitView(props) {
    let matchValue_3, businessUnitId_1;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram((tupledArg) => initEditView(tupledArg[0], tupledArg[1]), update_1, (_arg, _arg_1) => {
    }), [props.UserData, props.BusinessUnitId], undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const matchValue = state_1.Form;
    const matchValue_1 = state_1.BusinessUnits;
    let matchResult, businessUnits, form;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        businessUnits = matchValue_1.fields[0];
        form = matchValue.fields[0];
    }
    switch (matchResult) {
        case 0: {
            const editedId = BusinessUnitId__get_unwrap(props.BusinessUnitId);
            const childrenByParent = ofList(List_groupBy((bu) => bu.ParentId, businessUnits, {
                Equals: equals,
                GetHashCode: (x) => (structuralHash(x) | 0),
            }), {
                Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
            });
            const excludedIds = ofList_1(cons(editedId, toList(concat(unfold((queue) => {
                if (!isEmpty(queue)) {
                    const childIds = map((bu_1) => bu_1.Id, defaultArg(tryFind_1(head(queue), childrenByParent), empty()));
                    return [childIds, append(childIds, tail(queue))];
                }
                else {
                    return undefined;
                }
            }, singleton(editedId))))), {
                Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
            });
            return createElement(BusinessUnitForm, {
                BusinessUnits: filter((bu_2) => !contains(bu_2.Id, excludedIds), businessUnits),
                Dispatch: dispatch,
                Form: form,
                FormKind: state_1.FormKind,
                FormState: state_1.FormState,
                OnBack: (matchValue_3 = state_1.BusinessUnitId, (matchValue_3 == null) ? (() => {
                    RouterModule_nav(ofArray(["business-units"]), 1, 1);
                }) : ((businessUnitId_1 = matchValue_3, () => {
                    RouterModule_nav(ofArray(["business-units", BusinessUnitId__get_unwrap(businessUnitId_1)]), 1, 1);
                }))),
                OnSave: () => {
                    dispatch(new Msg(3, []));
                },
            });
        }
        default:
            return createElement(Skeleton, {
                Variant: "normal",
            });
    }
}

export function NewBusinessUnitView(props) {
    let elems;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initNewView, update_1, (_arg, _arg_1) => {
    }), props.UserData, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const t = useTranslation()[0];
    const patternInput_2 = reactApi.useState(false);
    const setBusinessUnitsFormTourDismissed = patternInput_2[1];
    const showBusinessUnitsFormTour = isBusinessUnitsTourFormPhase() && !patternInput_2[0];
    const clearBusinessUnitsTourFromUrl = () => {
        RouterModule_nav(ofArray(["business-units", "new" + RouterModule_encodeQueryString(withoutOnboardingTourQueryParams())]), 1, 1);
    };
    const matchValue = state_1.Form;
    const matchValue_1 = state_1.BusinessUnits;
    let matchResult, businessUnits, form;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        businessUnits = matchValue_1.fields[0];
        form = matchValue.fields[0];
    }
    switch (matchResult) {
        case 0:
            return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full", "flex", "flex-col"])], (elems = toList(delay(() => append_1(singleton_1(createElement(BusinessUnitForm, {
                BusinessUnits: businessUnits,
                Dispatch: dispatch,
                Form: form,
                FormKind: state_1.FormKind,
                FormState: state_1.FormState,
                OnBack: () => {
                    RouterModule_nav(ofArray(["business-units"]), 1, 1);
                },
                OnSave: () => {
                    dispatch(new Msg(3, []));
                },
            })), delay(() => {
                let Steps;
                return showBusinessUnitsFormTour ? singleton_1(createElement(TourGuide, (Steps = ofArray([new TourStep("[data-test-id=\'create-business-unit-form-name\']", t("onboarding.tour.business_units_form_name_title"), reactElement("div", {
                    children: t("onboarding.tour.business_units_form_name_content"),
                }), "bottom", true), new TourStep("[data-test-id=\'create-business-unit-form-select\']", t("onboarding.tour.business_units_form_parent_title"), reactElement("div", {
                    children: t("onboarding.tour.business_units_form_parent_content"),
                }), "bottom", true)]), {
                    IsRunning: true,
                    Locale: new TourGuideLocale(t("onboarding.tour.joyride_back"), t("onboarding.tour.joyride_close"), t("onboarding.tour.joyride_last"), t("onboarding.tour.joyride_next"), t("onboarding.tour.joyride_next_with_progress"), t("onboarding.tour.joyride_open"), t("onboarding.tour.joyride_skip")),
                    OnFinish: () => {
                        setBusinessUnitsFormTourDismissed(true);
                        clearBusinessUnitsTourFromUrl();
                    },
                    OnSkip: () => {
                        setBusinessUnitsFormTourDismissed(true);
                        clearBusinessUnitsTourFromUrl();
                    },
                    ScrollFirstStep: true,
                    Steps: Steps,
                }))) : empty_1();
            })))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
        default:
            return createElement(Skeleton, {
                Variant: "normal",
            });
    }
}

